import { get, post, del, patch } from "src/services/api";

const fetchCampaignManager = async ({ accountId, assistantId, paginationParams }) => {
  const endpoint = `/accounts/${accountId}/assistants/${assistantId}/outbound${paginationParams ? `?${paginationParams}` : ""}`;
  return await get({ endpoint });
};

const fetchCampaignTasks = async ({ accountId, campaignId, paginationParams }) => {
  const endpoint = `/accounts/${accountId}/campaigns/${campaignId}/tasks${paginationParams ? `?${paginationParams}` : ""}`;
  return await get({ endpoint });
};

const fetchAllCampaigns = async (params) => {
  const endpoint = `/accounts/${params.accountId}/campaigns`;
  return await get({ endpoint });
};

const fetchCampaign = async (params) => {
  const endpoint = `/accounts/${params.accountId}/campaigns/${params.campaignId}`;
  return await get({ endpoint });
};

const createCampaign = async ({ accountId, data }) => {
  const endpoint = `/accounts/${accountId}/campaigns`;
  return await post({ endpoint, data });
};

const deleteCampaign = async ({ accountId, campaignId, data }) => {
  const endpoint = `/accounts/${accountId}/campaigns/${campaignId}`;
  return await del({ endpoint, data });
};

const updateCampaign = async ({ accountId, campaignId, data }) => {
  const endpoint = `/accounts/${accountId}/campaigns/${campaignId}`;
  return await patch({ endpoint, data });
};

const updateCampaignRef = async ({ accountId, campaignId, data }) => {
  const endpoint = `/accounts/${accountId}/campaigns/${campaignId}/ref`;
  return await patch({ endpoint, data });
};

const fetchCampaignDataProcessor = async ({ accountId, campaignId }) => {
  const endpoint = `/accounts/${accountId}/campaigns/${campaignId}/data-processor`;
  return await get({ endpoint });
};

const fetchDataProcessorConfig = async ({ accountId, dataProcessorId }) => {
  const endpoint = `/accounts/${accountId}/data-processors/${dataProcessorId}`;
  return await get({ endpoint });
};

const importCampaignTasks = async ({ accountId, campaignId, dataProcessorConfigId, file, isTest }) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("dataProcessorConfigId", dataProcessorConfigId);
  formData.append("isTest", String(isTest));

  const endpoint = `/accounts/${accountId}/campaigns/${campaignId}/tasks/import`;
  return await post({
    endpoint,
    data: formData,
    headers: { "Content-Type": "multipart/form-data" }
  });
};

// Cancels every cancelable task on the campaign. Takes no body — the server derives the
// task set itself, so this is not a subset operation.
const cancelCampaignTasks = async ({ accountId, campaignId }) => {
  const endpoint = `/accounts/${accountId}/campaigns/${campaignId}/tasks/cancel`;
  return await post({ endpoint });
};

const fetchOutboundFilterTypes = async ({ accountId, assistantId }) => {
  const endpoint = `/accounts/${accountId}/assistants/${assistantId}/outbound/filters-types`;
  return await get({ endpoint });
};

export default {
  fetchCampaignManager,
  fetchCampaignTasks,
  fetchAllCampaigns,
  fetchCampaign,
  createCampaign,
  deleteCampaign,
  updateCampaign,
  updateCampaignRef,
  fetchCampaignDataProcessor,
  fetchDataProcessorConfig,
  importCampaignTasks,
  cancelCampaignTasks,
  fetchOutboundFilterTypes
};
